import React from "react";
import {
  IHighlightCommon,
  IHtmlHighlightInput,
  IPdfHighlightInput,
  PopoverOptionHighlighters,
} from "~/typings/annotate/annotation";
import useCommentContext from "../hooks/comment-context";
import { AddHighlightIcon, RemoveHighlightIcon } from "~/components/icons";

export default function AnnotateHighlight({
  highlight,
  config,
  closePopover,
}: {
  config: PopoverOptionHighlighters;
  highlight: IHighlightCommon;
  closePopover: () => void;
}) {
  const commentContext = useCommentContext();

  function addHighlight() {
    const { id, comments, canEdit, createdAt, profile, ...rest } = highlight;
    const highlightInput = {
      ...rest,
      model: "marker0",
      color: "#ffc7c7",
    } as IPdfHighlightInput | IHtmlHighlightInput;
    config
      .highlightAdd(highlightInput)
      .then((h) => {
        commentContext.selectThread(h.id as string);
        closePopover();
        return h;
      })
      .then(() => {
        closePopover();
      })
      .catch((err) => {
        // Let's keep the menu open to retry if wanted.
      });
  }

  const removeHighlight = () => {
    config
      .highlightRemove(highlight.id)
      .then(() => {
        closePopover();
      })
      .catch((err) => {
        // Let's keep the menu open to retry if wanted.
      });
  };

  return (
    <>
      {highlight.id == "temp" ? (
        <button
          onClick={addHighlight}
          className="flex text-sm sm:text-base justify-center h-10 px-2 items-center sm:px-4 cursor-pointer space-x-1"
        >
          <AddHighlightIcon className="h-5 w-5" />
        </button>
      ) : (
        <button
          onClick={removeHighlight}
          className="flex text-sm sm:text-base justify-center h-10 px-2 items-center sm:px-4 cursor-pointer space-x-1"
        >
          <RemoveHighlightIcon className="h-5 w-5" />
        </button>
      )}
    </>
  );
}
